import React, { lazy } from 'react';

import Footer from 'components/Footer';
import Header from 'components/Header';
import Password from 'components/Password';
import PASSWORDS from 'config/passwords';
import { Outlet } from 'react-router-dom';

import Loadable from './Loadable';

const Home = Loadable(lazy(() => import('../pages/Home')));
const About = Loadable(lazy(() => import('../pages/About')));

// Work
const ApPage = Loadable(lazy(() => import('../pages/ap')));
const Major = Loadable(lazy(() => import('../pages/major')));
const Shout = Loadable(lazy(() => import('../pages/shout')));
const CilaPage = Loadable(lazy(() => import('../pages/cila')));
const SwdCMS = Loadable(lazy(() => import('../pages/swd_cms')));
const Kooboon = Loadable(lazy(() => import('../pages/kooboon')));
const FlowwPage = Loadable(lazy(() => import('../pages/floww')));
const SwdPass = Loadable(lazy(() => import('../pages/swd_pass')));
const SeminarPage = Loadable(lazy(() => import('../pages/seminar')));
const MorseCode = Loadable(lazy(() => import('../pages/morse-code')));
const GrandUnity = Loadable(lazy(() => import('../pages/grand-unity')));
const HrManagement = Loadable(lazy(() => import('../pages/hr-management')));
const WirelessHouse = Loadable(lazy(() => import('../pages/wireless-house')));
const ShareFlight = Loadable(lazy(() => import('../pages/swd_share_flight')));
const CheckFlightPage = Loadable(lazy(() => import('../pages/check_flight')));

const PublishRoutes = {
  path: '/',
  element: (
    <>
      <Header />
      <main className="app-main">
        <Outlet />
      </main>
      <Footer />
    </>
  ),
  children: [
    { path: '/', element: <Home /> },
    { path: '/about', element: <About /> },

    {
      path: '/work',
      children: [
        { path: 'ap', element: <ApPage /> },
        { path: 'major', element: <Major /> },
        { path: 'cila', element: <CilaPage /> },
        { path: 'kooboon', element: <Kooboon /> },
        { path: 'floww', element: <FlowwPage /> },
        { path: 'sawasdee-cms', element: <SwdCMS /> },
        { path: 'seminar', element: <SeminarPage /> },
        { path: 'morse-code', element: <MorseCode /> },
        { path: 'sawasdee-pass', element: <SwdPass /> },
        { path: 'grand-unity', element: <GrandUnity /> },
        { path: 'share-flight', element: <ShareFlight /> },
        { path: 'influencer-platform', element: <Shout /> },
        { path: 'hr-management', element: <HrManagement /> },
        { path: 'wireless-house', element: <WirelessHouse /> },
        { path: 'check-flight', element: <CheckFlightPage /> },
        {
          path: 'test',
          element: (
            <Password pass={PASSWORDS.test}>
              <CheckFlightPage />
            </Password>
          ),
        },
      ],
    },
  ],
};

export default PublishRoutes;
